import { lazy } from "react";

export const Help = lazy(() => import("./routes/Help"));
export const ScratchView = lazy(() => import("./routes/Scratch"));
export const Dashboard = lazy(() => import("./routes/dashboard/Dashboard"));
